import React from 'react';
export function GuaranteeSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-127">
      <div className="max-w-4xl mx-auto" data-id="element-128">
        <div className="bg-bg-alt border border-primary/30 shadow-[0_0_30px_rgba(37,99,235,0.1)] rounded-3xl p-10 sm:p-16 text-center relative overflow-hidden" data-id="element-129">
          {/* Subtle background glow */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-1/2 pointer-events-none" style={{
          background: 'radial-gradient(ellipse at center top, rgba(37,99,235,0.04) 0%, transparent 70%)'
        }} data-id="element-130"></div>

          <div className="w-24 h-24 mx-auto bg-gradient-to-br from-primary/20 to-primary/5 border border-primary/30 rounded-full flex items-center justify-center mb-8 shadow-inner" data-id="element-131">
            <span className="text-5xl" data-id="element-132">🛡️</span>
          </div>

          <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-6 tracking-tight" data-id="element-133">
            HOL DIR DEINE ZEIT ZURÜCK ODER GELD ZURÜCK
          </h2>

          <p className="text-text-sec text-lg sm:text-xl leading-relaxed font-medium max-w-2xl mx-auto" data-id="element-134">
            Wir sind so überzeugt von der Wirksamkeit von HANDBALL-FIX, dass wir
            dir eine{' '}
            <span className="text-primary font-bold" data-id="element-135">
              7-Tage-Geld-zurück-Garantie
            </span>{' '}
            geben. Wenn du nicht spürst, dass deine Arbeit als Coach einfacher
            und organisierter geworden ist, erstatten wir dir jeden Cent.{' '}
            <span className="text-text-main font-bold" data-id="element-136">Ohne Fragen.</span>
          </p>
        </div>
      </div>
    </section>;
}